import React from 'react';
import CountUp from 'react-countup';

const FunFact2 = () => {
    return (
        <section className="wpo-fun-fact-section-s2">
            <div className="container">
                <div className="row">
                    <div className="col col-xs-12">
                        <div className="wpo-fun-fact-grids clearfix">
                            <div className="grid">
                                <div className="info">
                                    <h3><CountUp end={1} enableScrollSpy /></h3>
                                    <p>Année d'expérience</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><CountUp end={10} enableScrollSpy /></h3>
                                    <p>Spécialistes Experts</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><CountUp end={20} enableScrollSpy />+</h3>
                                    <p>Projets réussis</p>
                                </div>
                            </div>
                            <div className="grid">
                                <div className="info">
                                    <h3><CountUp end={20} enableScrollSpy />+</h3>
                                    <p>Clients satisfaits</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default FunFact2;